import { render } from "./Futahq.vue?vue&type=template&id=205c41fc&scoped=true"
import script from "./Futahq.vue?vue&type=script&lang=js"
export * from "./Futahq.vue?vue&type=script&lang=js"

import "./Futahq.vue?vue&type=style&index=0&id=205c41fc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-205c41fc"

export default script